module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "village.befd9f6b.png";